const isEmpty = (item?: string) => {
  return !item || item === ''
}

export default isEmpty